import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from 'components/forms/new/formikFormFields/BooleanToggle';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackStyling,
    stackSpacing,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const ZoomUserSyncField = ({ darkMode, disabled = false }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        User Sync
                    </FormLabel>
                    <Text sx={descriptionStyling}>
                        Enable automatic user synchronization.
                    </Text>
                </Box>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={BooleanToggle}
                        id="userSync"
                        name="userSync"
                        paddingTop="20px"
                        isDisabled={disabled}
                        darkMode={darkMode}
                    />
                    {isHovered && (
                        <FieldToolTip
                            label="Enable automatic user synchronization."
                            ariaLabel="zoom-user-sync-tip"
                            left="25px"
                            top="5px"
                        />
                    )}
                </Box>
            </Stack>
        </FormControl>
    );
};

export default ZoomUserSyncField;
